import { render } from "./SvgIcon.vue?vue&type=template&id=5c7bf8a4"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=5c7bf8a4&lang=sass"

import exportComponent from "/home/runner/work/wiki.zems.pro/wiki.zems.pro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__